import { inject, observer } from 'mobx-react'
import React from 'react'
import TableComponent from '../../components/Common/TableComponent'
import moment from 'moment'

const ManagementAssetWarehousePreviewModal = props => {
  const {
    listDataPreview,
    listDataCurrent,
    managementAssetTypes,
    isLoadingCreate,
  } = props

  const tableColumns = [
    {
      title: 'STT',
      width: 30,
      render: (id, record, index) => <span title={index + 1}>{index + 1}</span>,
    },
    {
      title: 'Loại văn phòng phẩm',
      width: 100,
      render: record => {
        const result = managementAssetTypes.find(
          item => item.id === record.asset_type_id
        )
        return (
          <p
            style={{
              marginBottom: '0px',
            }}>
            {result?.description}
          </p>
        )
      },
    },
    {
      title: 'Tên văn phòng phẩm',
      width: 120,
      render: record => (
        <p
          style={{
            marginBottom: '0px',
          }}>
          {record.asset_name}
        </p>
      ),
    },

    {
      title: 'Đơn vị tính',
      width: 100,
      render: record => (
        <p
          style={{
            marginBottom: '0px',
          }}>
          {record?.asset_unit_name}
        </p>
      ),
    },
    {
      title: 'Thuế',
      width: 60,
      render: record => (
        <p
          style={{
            marginBottom: '0px',
          }}>
          {record?.tax ? `${record?.tax}%` : '----'}
        </p>
      ),
    },
    {
      title: 'Đơn giá trước thuế',
      width: 100,
      render: record => (
        <p
          style={{
            marginBottom: '0px',
          }}>
          {record?.price
            ? parseFloat(record?.price).toLocaleString('vi-VN')
            : '----'}
        </p>
      ),
    },
    {
      title: 'Đơn giá sau thuế',
      width: 100,
      render: record => (
        <p
          style={{
            marginBottom: '0px',
          }}>
          {record?.total_money
            ? parseFloat(record?.total_money).toLocaleString('vi-VN')
            : '----'}
        </p>
      ),
    },
    {
      title: 'Số lượng trong kho',
      width: 90,
      render: record => (
        <p
          style={{
            marginBottom: '0px',
          }}>
          {record?.amount}
        </p>
      ),
    },
    {
      title: 'Ngày tạo',
      width: 70,
      render: () => {
        return (
          <p
            style={{
              marginBottom: '0px',
            }}>
            {moment(new Date()).format('DD/MM/YYYY')}
          </p>
        )
      },
    },
    {
      title: 'Trạng thái',
      width: 70,
      render: record => {
        return (
          <p
            style={{
              marginBottom: '0px',
              color: 'red',
            }}>
            {record.isDuplicate ? 'Văn phòng phẩm này đã có rồi' : ''}
          </p>
        )
      },
    },
  ]
  const filteredData = listDataPreview.map(preview => ({
    ...preview,
    isDuplicate: listDataCurrent.some(
      current => current.asset_name === preview.asset_name
    ),
  }))
  return (
    <>
      <TableComponent
        // @ts-ignore
        dataSource={filteredData}
        rowClassName={record => (record.isDuplicate ? 'highlight-row' : '')}
        // @ts-ignore
        columns={tableColumns}
        pagination={false}
        loading={isLoadingCreate}
      />
    </>
  )
}

export default inject(
  'managementAssetWarehouseStore',
  'selectPeopleStore'
)(observer(ManagementAssetWarehousePreviewModal))
